export const ConsumerNetIncomeFormMessages = {
  submitButton: {
    id: 'Pages.ConsumerNetIncome.Form.submitButton',
    description: 'text for the submit button'
  }
}
